import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=10948e4d&scoped=true&"
import script from "./testPage.vue?vue&type=script&lang=ts&"
export * from "./testPage.vue?vue&type=script&lang=ts&"
import style0 from "./testPage.vue?vue&type=style&index=0&id=10948e4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10948e4d",
  null
  
)

export default component.exports